module.exports = __webpack_public_path__ + "assets/cb1164f057e301e7d0fe8f1b7743a768.mp3";